import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { loadRepoListPage, loadRepoTagCatalog } from '@/server/functions/pages/repo-list';
import { getRepo } from '@/server/functions/repo';

type RepoListPageOpts = {
  tags?: string[];
  search?: string;
  sortBy?: 'name' | 'createdAt';
  sortOrder?: 'asc' | 'desc';
};

const repoListQueryKey = (orgSlug: string, opts?: RepoListPageOpts) => ['repo-list-page', orgSlug, opts ?? {}] as const;

const repoListQueryFn =
  (orgSlug: string, opts?: RepoListPageOpts) =>
  ({ pageParam }: { pageParam: string | undefined }) =>
    loadRepoListPage({
      data: {
        orgSlug,
        tags: opts?.tags,
        search: opts?.search,
        cursor: pageParam,
        sortBy: opts?.sortBy,
        sortOrder: opts?.sortOrder,
      },
    });

export const repoListInfiniteQueryOptions = (orgSlug: string, opts?: RepoListPageOpts) =>
  infiniteQueryOptions({
    queryKey: repoListQueryKey(orgSlug, opts),
    queryFn: repoListQueryFn(orgSlug, opts),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });

export const repoTagCatalogQueryOptions = (orgSlug: string) =>
  queryOptions({
    queryKey: ['repo-tag-catalog', orgSlug],
    queryFn: () => loadRepoTagCatalog({ data: { orgSlug } }),
    // Fetched on demand when the Labels panel opens; keep it warm briefly so
    // reopening the panel doesn't refetch.
    staleTime: 60_000,
  });

export const repoQueryOptions = (orgSlug: string, name: string) =>
  queryOptions({
    queryKey: ['repo', orgSlug, name],
    queryFn: () => getRepo({ data: { orgSlug, name } }),
  });
